{
  "projectAttributes": {
    "title": "Configuración de atributos",
    "subtitle": "Aquí puede agregar y eliminar atributos predefinidos que los usuarios de su proyecto pueden ver y usar.",
    "predefined_title": "Atributos predefinidos",
    "predefined_text": "Personalice los atributos predefinidos de su proyecto, que se pueden agregar a las capas del plan.",
    "no_attributes": "No hay atributos de proyecto, crea uno usando el botón de agregar atributos que se encuentra arriba",
    "active_tab": "Activo",
    "deprecated_tab": "Inactivo",
    "no_deprecated_attributes": "No hay atributos de proyecto inactivos",
    "deprecate_confirmation_title": "¿Desactivar el atributo?",
    "deprecate_confirmation_message": "Este atributo está en uso y no se puede eliminar. En su lugar, se desactivará. Los atributos inactivos se ocultan al agregar atributos a las capas, pero permanecerán en las capas en las que ya se han agregado.",
    "delete_confirmation_title": "¿Eliminar un atributo?",
    "delete_confirmation_message": "¿Está seguro de que desea eliminar este atributo? Esta acción no se puede deshacer.",
    "restore_button": "Restaurar"
  }
}